export const FETCH_PRESENTATION_HISTORY_SUCCESS =
  "FETCH_PRESENTATION_HISTORY_SUCCESS";
export const LOADING_PRESENTATION_HISTORY = "LOADING_PRESENTATION_HISTORY";
